import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import Device from 'src/app/services/device.model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-io-ports',
  templateUrl: './io-ports.component.html',
  styleUrls: ['./io-ports.component.scss']
})
export class IoPortsComponent implements OnInit, OnDestroy {
  public device: Device = new Device();
  public devices: Array<Device> = [];
  public registerForm: FormGroup;
  public submitted = false;
  public enableDisablePageLoader: boolean = false;
  public submitting: boolean = false;

  constructor(
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    public deviceService: DeviceService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) {
    this.device = new Device();
    this.registerForm = this.formBuilder.group({
      serial_number: ['', Validators.required],
      port: ['usb', Validators.required],
      key: ['enable', Validators.required]
    });
  }

  public async ngOnInit() {
    try {
      window.scrollTo(0, 0);
      this.enableDisablePageLoader = true;
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.devices = await this.deviceService.getAllDevices();
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  public ngOnDestroy(): void {
    this.deviceService.cancelOnGoingHttpRequests();
  }

  get f() {
    return this.registerForm.controls;
  }

  public async ioPorts() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    const formData = this.registerForm.value;
    this.device.serial_number = formData.serial_number;
    this.device.port = formData.port;
    this.device.key = formData.key;

    try {
      this.submitting = true;
      let res = await this.deviceService.ioPorts(this.device);
      if (res && res.ioPort) {
        this.toastrService.success(
          `${this.device.port.toUpperCase()} ${this.device.key}d successfully`,
          '',
          { timeOut: 2000 }
        );
        this.submitted = false;
        this.device = new Device();
        this.registerForm.reset({ port: 'usb', key: 'enable' });
      }
      this.submitting = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.submitting = false;
    }
  }
}